import { useTranslation } from 'react-i18next';

import { TextareaField } from 'fields';

export default function Notes() {
  const { t } = useTranslation('CreateOrder');

  return (
    <TextareaField
      name="customerNotes"
      label={t('CustomerDetails.labels.notes')}
      placeholder={t('CustomerDetails.placeholders.notes')}
    />
  );
}
